(function () {
  function getCols(root) {
    return window.matchMedia('(min-width: 750px)').matches
      ? parseInt(root.dataset.colsDesktop, 10) || 4
      : parseInt(root.dataset.colsMobile, 10) || 2;
  }

  function isItemHidden(item) {
    if (item.classList.contains('ksp-lm-revealed')) return false;
    return window.getComputedStyle(item).display === 'none';
  }

  function makeVisible(item) {
    item.classList.add('ksp-lm-revealed');
    // Dawn scroll-animations leave newly shown cards at opacity ~0
    item.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
    item.style.opacity = '1';
    item.style.transform = 'none';
    item.style.animation = 'none';
  }

  function initLoadMore(root) {
    const grid = root.querySelector('[data-ksp-load-more-grid]');
    const button = root.querySelector('[data-ksp-load-more-btn]');
    const sentinel = root.querySelector('[data-ksp-load-more-sentinel]');
    if (!grid) return;

    const items = Array.from(grid.querySelectorAll('[data-ksp-load-more-item]'));
    if (!items.length) return;

    const batchRows = parseInt(root.dataset.batchRows, 10) || 2;
    const autoScroll = root.dataset.autoScroll !== 'false';
    let loading = false;
    let done = false;

    function hasHiddenItems() {
      return items.some(isItemHidden);
    }

    function updateButton() {
      if (!button) return;
      const hasHidden = hasHiddenItems();
      if (!hasHidden || autoScroll) {
        button.hidden = true;
        button.style.display = 'none';
        return;
      }
      button.hidden = false;
      button.style.display = '';
    }

    function revealNextBatch() {
      if (loading || done) return false;
      const hiddenItems = items.filter(isItemHidden);
      if (!hiddenItems.length) {
        done = true;
        updateButton();
        return false;
      }

      loading = true;
      const batchSize = Math.max(batchRows * getCols(root), 1);
      hiddenItems.slice(0, batchSize).forEach(makeVisible);
      loading = false;

      if (!hasHiddenItems()) done = true;
      updateButton();
      return !done;
    }

    function sentinelIsNear() {
      if (!sentinel) return false;
      const rect = sentinel.getBoundingClientRect();
      const margin = 480;
      return rect.top < window.innerHeight + margin && rect.bottom > -80;
    }

    function pump() {
      if (done || loading) return;
      var guard = 0;
      while (!done && hasHiddenItems() && sentinelIsNear() && guard < 16) {
        revealNextBatch();
        guard += 1;
      }
    }

    if (button) {
      button.addEventListener('click', function () {
        revealNextBatch();
      });
    }

    if (autoScroll) {
      var ticking = false;
      function onScrollOrResize() {
        if (ticking || done) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          ticking = false;
          pump();
        });
      }

      window.addEventListener('scroll', onScrollOrResize, { passive: true });
      window.addEventListener('resize', onScrollOrResize);

      if (sentinel && 'IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            if (entries.some(function (entry) { return entry.isIntersecting; })) {
              pump();
            }
          },
          { root: null, rootMargin: '480px 0px', threshold: 0 }
        );
        observer.observe(sentinel);
      }

      // Short grids: sentinel may already be near on first paint
      pump();
      window.setTimeout(pump, 100);
      window.setTimeout(pump, 400);
    }

    updateButton();
  }

  function initAll() {
    document.querySelectorAll('[data-ksp-load-more]').forEach(initLoadMore);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
